import TagManager from 'react-gtm-module';

const createCORSRequest = (method, url) => {
  let xhr = new XMLHttpRequest();
  if ("withCredentials" in xhr) {
    // Check if the XMLHttpRequest object has a "withCredentials" property.
    // "withCredentials" only exists on XMLHTTPRequest2 objects.
    xhr.open(method, url, true);

  } else if (typeof XDomainRequest !== "undefined") {
    // Otherwise, check if XDomainRequest.
    // XDomainRequest only exists in IE, and is IE's way of making CORS requests.
    xhr = new XDomainRequest();
    xhr.open(method, url);

  } else {
    // Otherwise, CORS is not supported by the browser.
    xhr = null;
  }
  xhr.setRequestHeader("Content-Type", "application/json");

  return xhr;
};

const successDataLayer = (submissionComplete) => {
  TagManager.dataLayer({
    dataLayer: {
      formDesc: 'giro',
      formSubmit: submissionComplete ? 'Success' : 'Failed',
      event: 'formSubmission'
    },
  });
};

const sendFormHeightMessage = () => {
  const formHeight = document.getElementById('contact-form') !== null
    ? document.getElementById('contact-form').clientHeight
    : '1000';
  window.parent.postMessage('{"iframe_height":"' + formHeight + '"}', '*');
};

  // To ensure parity with Contact Service and data
const updateFormValueKeys = (formValues) => {
    // Doing this the long way to avoid weird state pointer issues:
    const updatedFormValues = {
      address_1: formValues.address1,
      address_2: formValues.address2,
      address_3: formValues.address3,
      campaign: formValues.campaign,
      country: formValues.country,
      email_address: formValues.email_address,
      first_name: formValues.first_name,
      last_name: formValues.last_name,
      organisation_name: formValues.organisation_name,
      organisation_type: formValues.organisation_type,
      phone_number: formValues.phone_number,
      postal_code: formValues.postcode,
      town: formValues.town,
      which_campaign: formValues.which_campaign,
    }

    return updatedFormValues;
  };

export { createCORSRequest, successDataLayer, sendFormHeightMessage, updateFormValueKeys };
